import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { filter, map } from "lodash";
import { useHistory, useLocation } from "react-router-dom";
import { decode, encode, toaster } from "Helpers/index";

import { Row, Col } from "antd";

// SHARED COMPONENT
import { DataTable, Button, SelectInput } from "@life-line-lab/components-react";
import DataTableFilter from "Components/shared/data-table-filter";

import { BasicModal } from "@life-line-lab/components-react";
import AssignDriverModal from "Components/delivery-management/parcel-tracking-modals/assign-driver-modal/assign-driver-modal";
import useSearch from "Hooks/search.hook";
import { routeToOrderView } from "Helpers/route-order-view";

export interface Option {
  label: string;
  value: string;
}
export interface CompletedParcelsListProps {
  parcelList: any;
  onFilter: any;
  initialStatus: any;
}

const CompletedCustomerList: React.FC<CompletedParcelsListProps> = ({
  parcelList,
  onFilter,
  initialStatus,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const initialFilter: any = {
    status: "",
  };
  const [filterState, setFilterState] = useState<{ [key: string]: string | boolean }>(
    initialFilter
  );
  const { handleSearch } = useSearch({ onFilter, filterState, setFilterState });

  const handleOrderView = (orderID) => {
    const params = 'module=delivery&tabKey=3'
    routeToOrderView(orderID, location, history, params)
  };

  const initialFilterSelection = [
    {
      key: "status",
      name: "status",
      label: t("label.filterByStatus"),
      placeholder: t("placeholder.byStatus"),
      value: filterState?.status,
      options: [{ label: t("option.all"), value: "" }].concat(
        initialStatus.map((option) => {
          return {
            label: option?.charAt(0) + option?.substring(1).toLowerCase().replace("_", " "),
            value: option,
          };
        })
      ),
    },
  ];

  const [filterSelection, setFilterSelection] = useState<any>(initialFilterSelection);

  const handleFilterSelection = (selection) => {
    setFilterState((prevFilter) => ({
      ...prevFilter,
      status: selection.status ?? null,
    }));
  };

  const rearrangedParcelList = parcelList?.map((parcel, index) => ({
    _id: parcel?.orders[index]?._id,
    orderCode: parcel?.orders[index]?.orderCode,
    parcelList: parcel?.parcelList[index],
    status: parcel?.status,
  }));

  const columns: any = [
    {
      title: t("label.parcelOrderNo").toLocaleUpperCase(),
      dataIndex: "orderCode",
      width: 120,
      ellipsis: true,
      render: (_: any, record: any) => {
        return <a className="clickable-id">{record?.orderCode}</a>;
      },
      onCell: (record, rowIndex) => {
        return {
          onClick: (e: React.MouseEvent<HTMLElement>) => {
            handleOrderView(record._id);
          },
        };
      },
    },
    {
      title: t("label.parcelTrackingNo").toLocaleUpperCase(),
      dataIndex: ["parcelList", "trackingNumber"],
      width: 80,
      ellipsis: true,
    },
    {
      title: t("label.status").toLocaleUpperCase(),
      dataIndex: "status",
      width: 100,
      ellipsis: true,
      render: (_: any, record: any) => {
        return (
          <div className="mt-5">
            <span className={`status ${record.status}`}>
              {record?.status?.replaceAll("_", " ") || ""}
            </span>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="parcel-order-list status-selector">
        <DataTable
          rowKey={(record: any) => {
            return record._id;
          }}
          columns={columns}
          dataSource={rearrangedParcelList || []}
          scroll={{ x: true }}
          title={() => (
            <Row className="filter-component">
              <DataTableFilter
                searchPlaceholder={t("placeholder.searchTrackingNo")}
                onSearch={handleSearch}
                onFilter={(selection) => handleFilterSelection(selection)}
                // filterLabel={t("label.filter")}
                renderFilterSelection={filterSelection}
              />
            </Row>
          )}
        />
      </div>
    </>
  );
};

export default CompletedCustomerList;
